import { IpInfo, IpInfoType } from '@apparel/core/vendor/ipInfo/api';
import { useEffect, useState } from 'react';

export function useIpInfo(): { info: Partial<IpInfoType>; loading: boolean } {
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState<Partial<IpInfoType>>({});

    useEffect(() => {
        (async () => {
            setLoading(true);

            const info = await IpInfo.instance.getCurrentInfo();
            setInfo(info);

            setLoading(false);
        })();
    }, ['']);

    return {
        info,
        loading,
    };
}
